import { all, takeLatest, call, put } from 'redux-saga/effects'

import api from '@/services/api'
import handleErrors from '@/services/handleErrors'
import apiEndPoints from '@/consts/apiEndPoints'

import {
  getPossibleDatesRequest,
  getPossibleDatesFailure,
  getPossibleDatesSuccess,
} from './reducer'

export function* getPossibleDatesData() {
  const response = yield call(
    api.get,
    apiEndPoints.miscellaneous.possibleDates
  )

  const {
    message,
    dates,
  } = response.data

  return { message, dates }
}

function* getPossibleDates() {
  try {
    const { message, dates } = yield call(getPossibleDatesData)

    yield put(getPossibleDatesSuccess({ message, dates }))
  } catch (error) {
    yield put(getPossibleDatesFailure())
    handleErrors(error, 'Não foi possível buscar as datas disponíveis')
  }
}

export default all([takeLatest(getPossibleDatesRequest.type, getPossibleDates)])
